import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import containerConnect from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { getShareUrl } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import { get } from 'lodash';
import SaveConfiguration from '../Components/SaveConfiguration/index';

const mapStateToProps = ({ ui, configurator }) => ({
  Component: SaveConfiguration,
  ProgressComponent: CircularProgress,
  show: !!ui.visibilityMap.saveConfiguration,
  workInProgress: !!ui.backgroundWorkMap.saveConfiguration,
  errorMessage: ui.error && ui.error.message,
  code: configurator.configuration.code || '',
  savedconfiguration: configurator.configuration,
  loadLoginInfoInProgress: !!ui.backgroundWorkMap.loadLoginInfo,
  shareUrl: (() => {
    const { iso } = get(configurator.configuration, 'information.languageSettings');
    let language = 'de';
    switch (iso) {
      case 'en_GB': {
        language = 'en';
        break;
      }
      case 'fr_FR': {
        language = 'fr';
        break;
      }
      default: {
        //  language = "de"
      }
    }
    const formerUrl = getShareUrl(configurator);

    return formerUrl.replace('{lang}', language);
  })(),
});

const mapDispatchToProps = () => ({
  onClose: () => Services.ui.hide('saveConfiguration'),
  onOkClick: () => Services.ui.hide('saveConfiguration'),
});

export default containerConnect(mapStateToProps, mapDispatchToProps);
